import { Box, Container, Grid, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { motion } from "framer-motion";

const ServiceDetailedSections = ({ service }) => {
  return (
    <Box sx={styles.section}>
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box sx={styles.header}>
          <Typography sx={styles.eyebrow}>Service Details</Typography>

          <Typography sx={styles.heading}>
            What’s Included in {service.title}
          </Typography>

          <Typography sx={styles.description}>
            Explore the key service areas designed to help your business improve
            efficiency, strengthen operations, and get maximum value from SAP.
          </Typography>
        </Box>

        {/* Detailed Cards */}
        <Grid container spacing={3}>
          {service.detailedSections.map((item, index) => (
            <Grid item size={{ xs: 12, md: 6 }} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 35 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
                viewport={{ once: true }}
              >
                <Box
                  sx={{
                    ...styles.card,
                    ...styles.featuredCard,
                    borderTop: `4px solid ${service.accent}`,
                  }}
                >
                  <Box sx={styles.cardTop}>
                    {/* <Box
                      sx={{
                        ...styles.number,
                        background: `${service.accent}22`,
                        color: service.accent,
                      }}
                    >
                      {String(index + 1).padStart(2, "0")}
                    </Box> */}

                    {/* <ArrowForwardIcon
                      sx={{
                        color: service.accent,
                        transform: "rotate(-45deg)",
                      }}
                    /> */}
                  </Box>

                  <Typography sx={styles.cardTitle}>{item.title}</Typography>

                  <Typography sx={styles.cardText}>
                    {item.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ServiceDetailedSections;

const styles = {
  section: {
    py: { xs: 7, md: 11 },
    background:
      "linear-gradient(180deg, #ffffff 0%, #f7f9fc 55%, #ffffff 100%)",
  },

  header: {
    textAlign: "center",
    maxWidth: 850,
    mx: "auto",
    mb: { xs: 5, md: 7 },
  },

  eyebrow: {
    display: "inline-flex",
    px: 2,
    py: 0.8,
    borderRadius: "50px",
    background: "rgba(8,45,99,0.08)",
    color: "#082d63",
    fontSize: "0.85rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "1px",
    mb: 2,
  },

  heading: {
    color: "#071525",
    fontSize: { xs: "2rem", md: "3rem" },
    fontWeight: 850,
    lineHeight: 1.15,
    letterSpacing: "-0.8px",
  },

  description: {
    mt: 2,
    color: "#64748b",
    fontSize: { xs: "0.98rem", md: "1.08rem" },
    lineHeight: 1.8,
  },

  card: {
    height: "100%",
    p: { xs: 3, md: 4 },
    borderRadius: "28px",
    background: "rgba(255,255,255,0.86)",
    border: "1px solid rgba(7,21,37,0.08)",
    boxShadow: "0 24px 70px rgba(7,21,37,0.08)",
    transition: "0.35s ease",
    position: "relative",
    overflow: "hidden",

    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 34px 90px rgba(7,21,37,0.14)",
    },

    "&::before": {
      content: '""',
      position: "absolute",
      width: 180,
      height: 180,
      right: -90,
      bottom: -90,
      borderRadius: "50%",
      background: "rgba(8,45,99,0.06)",
    },
  },

  featuredCard: {
    minHeight: { xs: "auto", md: "auto" },
    background: "fff",
    color: "#fff",

    "& .card-title": {
      color: "#fff",
    },

    "& .card-text": {
      color: "rgba(255,255,255,0.76)",
    },
  },

  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
  },

  number: {
    width: 48,
    height: 48,
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
  },

  cardTitle: {
    className: "card-title",
    color: "#071525",
    fontSize: { xs: "1.35rem", md: "1.6rem" },
    fontWeight: 800,
    mb: 1.5,
  },

  cardText: {
    className: "card-text",
    color: "#64748b",
    fontSize: "1rem",
    lineHeight: 1.85,
  },
};
